import React, { useEffect, useRef, useState } from "react";
import { List as DhxList } from "dhx-suite";
import { SnippetSearchResult } from "../models";

interface SearchResultsProps {
    searchResults: SnippetSearchResult[];
    currentSnippetId: string;
    onSelect: (id: string) => void;
}

const listConfig: { [key: string]: any } = {
    template: (item: SnippetSearchResult) => `
    <span class="st-search--list__name ${item.current ? "st-search--list__current" : ""}">
        ${item.widgetName ? `<b>${item.widgetName}.</b> ` : ""}${item.title}
    </span>`
};

export const SearchList = ({ searchResults, currentSnippetId, onSelect }: SearchResultsProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const [list, setList] = useState<DhxList<SnippetSearchResult>>();

    useEffect(() => {
        if (!list && ref.current) {
            const newList = new DhxList<SnippetSearchResult>(ref.current, listConfig);
            
            const ul = (newList as any).getRootNode() as HTMLUListElement;
            ul.addEventListener('scroll', () => {
                localStorage.setItem("searchListScroll", ul.scrollTop.toString());
            });
            setList(newList);

        }
        if (list) {
            list.events.on("click", onSelect);
            const ul_view = (list as any).getRootView() as HTMLDivElement;
            (ul_view as any).hooks.didRedraw = (vm: any) => {
                const scroll = localStorage.getItem("searchListScroll");
                if (scroll === "scrollToSnippet") {
                    const current = vm.node.el.querySelector(`[dhx_id="${currentSnippetId}"]`);
                    if (current) {
                        current.scrollIntoView({ block: "start" });
                    }
                } else {
                    vm.node.el.scrollTop = scroll ? parseInt(scroll) : 0;
                }
            }
            return () => list.events.detach("click");
        }
        return undefined;
    });

    useEffect(() => {
        if (list) {
            list.data.removeAll();
            list.data.parse(searchResults.map(i => ({ ...i, id: i.url, current: i.url === currentSnippetId })));
        }
    }, [searchResults, currentSnippetId, list]);

    return <div className="st-search--list" ref={ref}></div>;
};
